import { render, staticRenderFns } from "./info-modal.vue?vue&type=template&id=8a6c5564&"
import script from "./info-modal.vue?vue&type=script&lang=ts&"
export * from "./info-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports